import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { TRANSLATION_NS } from '@contact/upgrade';

@NgModule({})
export class PageNotFoundForRootModule {
  constructor(@Optional() @SkipSelf() parentModule: PageNotFoundForRootModule) {
    if (parentModule) throw new Error(`[PageNotFoundForRootModule] module is already loaded`);
  }

  static instance(): ModuleWithProviders<PageNotFoundForRootModule> {
    return {
      ngModule: PageNotFoundForRootModule,
      providers: [
        {
          provide: TRANSLATION_NS,
          useValue: 'pagenotfound',
          multi: true,
        },
      ],
    };
  }
}
